import { doGet, doPut } from "../../../api/baseAPI"
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant"
import { setTableLoading } from "../../../store/reducer/page.reducer"
import { checkValidationToken } from "../../../util/errorHandler"

export const getListUom = async (token, refresh_token, param, dispatch) => {
  const url = `${GROLOG_URL}/uom?page=1&limit=10&order=id desc`
  let result = { data: undefined, ok: false }
  dispatch(setTableLoading(true))
  try {
      const response = await doGet(token, url, null);
      if (response) {
          result.ok = true;
          result.data = response?.data?.nexsoft?.payload?.data?.content
      }
  } catch (error) {
      checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const getDetail = async (token, refresh_token, id, dispatch) => {
  const url = `${GROLOG_URL}/uom/${id}`;
  let result = { data: undefined, ok: false }
  dispatch(setTableLoading(true))
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const update = async (token, data, id) => {
  const url = `${GROLOG_URL}/uom/${id}`;
  let result = { success: false, message: undefined }

  try {
    const response = await doPut(url, token, data);
    if (response?.data?.success) {
      result.success = true
      result.message = response?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;

    if (errorCode === 400) {
      result.success = false;
      result.message = error?.response?.data?.payload?.message;
    }
  }

  return result;
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
  const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq uom, primary_key eq ${id}`;
  let result = { data: undefined, ok: false }

  try {
      const response = await doGet(token, url, null);
      if (response) {
          result.ok = true;
          result.data = response?.data?.payload
      }
  } catch (error) {
      checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}